import { TIMEZONE } from "../renderer/constants.js";

const dateFormat = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: TIMEZONE,
});

export const Date = ({ date }: { date?: Date }) => {
  return <time dateTime={date?.toISOString()}>{dateFormat.format(date)}</time>;
};
